/*!
  * Bootstrap v4.0.0 (https://getbootstrap.com)
  * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
const $ = jQuery;
const CONSOLE$ = { log: console.log, warn: console.warn, error: console.error, debug: console.debug, trace: console.trace };
const DEBUG$ = { log: true, warn: true, error: true, debug: true, trace: true};

function ts() {
    return new Date().toISOString();
}

console.log = function (...args) {
    if (DEBUG$.log) {
        CONSOLE$.log(`MESSAGE [${ts()}]:`, ...args);
    }
};

console.warn = function (...args) {
    if (DEBUG$.warn) {
        CONSOLE$.warn(`WARNING [${ts()}]:`, ...args);
    }
};

console.error = function (...args) {
    if (DEBUG$.error) {
        CONSOLE$.error(`ERROR [${ts()}]:`, ...args);
    }
};

console.debug = function (...args) {
    if (DEBUG$.debug) {
        CONSOLE$.log(`DEBUG [${ts()}]:`, ...args);
    }
};

console.trace = function (...args) {
    if (DEBUG$.trace) {
        CONSOLE$.log(`TRACE [${ts()}]:`, ...args);
    }
};

console.traceLog = function (...args) {
    if (DEBUG$.trace) {
        CONSOLE$.trace(`TRACE [${ts()}]:`, ...args);
    }
};

function compararDestinos(urlRelativa, urlAbsoluta) {
    let r = String(urlRelativa || "").trim().toLowerCase().replace(/\/+$/, "");
    let a = String(urlAbsoluta || "").trim().toLowerCase().replace(/\/+$/, "");

    if (!r || !a) return false;

    return a === r || a.endsWith(r) || r.endsWith(a);
}

const handleNavMenus = function () {
    $(".navmenu .menu-item").each(function (_, item) {

        const a$ = $(item).children("a").first();

        if (a$.length > 0) {
            const parent$ = a$.parent();
            const data = {
                text: a$.html(),
                target: a$.attr("href")
            };

            parent$.data("nav", data);
            parent$.prepend("<span>" + data.text + "</span>");

            parent$.on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                const info = $(this).data("nav");
                if (info && info.target) {
                    window.location.href = info.target;
                }
            });

            const currentUrl = window.location.pathname;
            const targetUrl = data.target;

            const matched = compararDestinos(currentUrl, targetUrl);

            if (matched) {
                parent$.addClass("current");
            }

            a$.remove();
        }
    });
};

function removeExpendables() {

    var expendables$ = $(".expendable");
    expendables$.remove();

}

$(document).ready(function () {
    handleNavMenus();
    removeExpendables();
    
    const dropMenu$ = $(".dropmenu");
    if (dropMenu$.length>0) {
        dropMenu$.on("click", function() {
            
            console.log("Clicked on dropmenu");
            
            event.stopPropagation();
            event.preventDefault();
            
            const drawer$ = $(".cabval-dropdown-menu");
            console.log(drawer$);
            if (drawer$.length>0) {
                drawer$.removeClass("hidden");
                drawer$.addClass("open");
                
                document.querySelectorAll('.cabval-dropdown-menu li br').forEach(br => {
                    br.replaceWith(' ');
                });
            }
            
        });
    }
    
});